export default __webpack_public_path__ + "static/media/poligrafia_og.28326abc.jpg";